import { MfaLinks } from './multi-factor-authentication.interfaces';

export interface PingFederateError {
  error?: string;
  code?: string;
  message?: string;
  userMessage?: string;
  details?: ErrorDetails[];
  id?: string;
  pluginTypeId?: string;
  status?: string;
  requestContext?: RequestContext;
  _links?: MfaLinks;
}

export interface Errors {
  code: string;
}

export interface ErrorDetails {
  code?: string;
  message?: string;
  userMessage?: string;
  quotaLimit?: number;
  coolDownExpiresAt?: number;
  attemptsRemaining?: number;
  target?: string;
  satisfiedValidators?: string[] | null;
  failedValidators?: FailedValidator[] | null;
}

interface FailedValidator {
  userMessage: string;
}

export interface ErrorResponse {
  errors: Errors[];
}

export interface RequestContext {
  clientId?: string;
  pluginId?: string;
  trackedHttpParams?: TrackedHttpParams;
  applicationName?: string;
  extendedProperties?: ExtendedProperties;
}

export interface TrackedHttpParams {
  scope?: string[] | null;
  response_type?: string[] | null;
  client_id?: string[] | null;
}

export interface ExtendedProperties {
  Type?: string;
  appId?: string;
}
